import BaseApi, { FetchMethodType } from 'api/BaseApi';
import TokenUtils from 'utils/TokenUtils';
import { RequestError } from 'errors/RequestError';
import { IAuthResponse } from 'api/digifi/types';
import { HttpStatusCode } from 'enums/HttpStatusCode';
import AppHeaders from 'enums/AppHeaders';

export interface ISignInParams {
  email: string;
  password: string;
  recaptchaToken?: string | null;
}

export interface ISessionsApi {
  signIn(params: ISignInParams): Promise<IAuthResponse>;
  logout(): Promise<void>;
  validateToken(): Promise<void>;
}

export default class SessionsRestApi extends BaseApi implements ISessionsApi {
  public signIn(params: ISignInParams): Promise<IAuthResponse> {
    return this.fetch('/sessions', {
      method: FetchMethodType.POST,
      body: {
        email: params.email,
        password: params.password,
      },
      headers: new Headers({
        ...(params.recaptchaToken ? { [AppHeaders.RecaptchaToken]: params.recaptchaToken } : {}),
      }),
    });
  };

  public logout(): Promise<void> {
    return this.fetch('/sessions', {
      method: FetchMethodType.DELETE,
    });
  }

  public validateToken(): Promise<void> {
    if (!TokenUtils.getAccessToken()) {
      throw new RequestError('No refresh token was found', HttpStatusCode.BadRequest);
    }

    return this.fetch('/sessions/token-status', {
      method: FetchMethodType.PUT,
    });
  }
}
